import { render, staticRenderFns } from "./recallRetrieveCheck.vue?vue&type=template&id=480725ee&scoped=true"
import script from "./recallRetrieveCheck.vue?vue&type=script&lang=js"
export * from "./recallRetrieveCheck.vue?vue&type=script&lang=js"
import style0 from "./recallRetrieveCheck.vue?vue&type=style&index=0&id=480725ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480725ee",
  null
  
)

export default component.exports